import { createEntityAdapter } from '@reduxjs/toolkit';
import { OrderParams } from '../orders.types';

const adapter = createEntityAdapter<OrderParams>();

export default adapter;
